function TyC() {
    return (
        <>
            <div className="App d-flex justify-content-center bg-dark text-white p-4">

                <div className="col-12 bg-dark text-white justificado my-4 mb-4" style={{overflowY: "auto"}}>
                    <h1>
                        1. ACEPTACIÓN DE LOS TÉRMINOS
                    </h1>
                    <p>
                        Al registrarte, acceder o utilizar la aplicación o plataforma de Yourny (de ahora en adelante referenciada como “la Plataforma”),
                        aceptas estos Términos y Condiciones. Si no estás de acuerdo con alguno de los puntos aquí expuestos, te recomendamos no utilizar la Plataforma.
                    </p>
                    <br />
                    <h1>
                        2. OBJETIVO DE LA PLATAFORMA
                    </h1>
                    <p>
                        Yourny es una comunidad enfocada en compartir experiencias, consejos, fotografías y contenidos relacionados con viajes,
                        turismo y cultura. Promovemos la convivencia respetuosa y la colaboración entre viajeros de todo el mundo.
                    </p>
                    <br />
                    <h1>
                        3. RESPONSABILIDAD DEL USUARIO
                    </h1>
                    <p>
                        El usuario es único responsable del contenido que se publique, comparta o comente dentro de la Plataforma, incluyendo textos,
                        imágenes, videos, enlaces o cualquier otro tipo de material.
                        <br />
                        <br />
                        El usuario se compromete a:
                        <ul>
                            <li>
                                Publicar únicamente contenido propio o sobre el cual tenga los derechos necesarios.
                            </li>
                            <li>
                                Evitar comentarios ofensivos, discriminatorios, violentos o que vulneren derechos de terceros.
                            </li>
                            <li>
                                Mantener un comportamiento respetuoso hacia otros usuarios y moderadores.

                            </li>
                            <li>
                                No utilizar la Plataforma con fines comerciales no autorizados, incluyendo venta o intercambio de cuentas.
                            </li>
                            <li>
                                No acosar, hostigar o stalkear (espiar los perfiles de otros usuarios con la finalidad de recopilar información) a otros usuarios bajo ningún motivo.
                            </li>
                        </ul>
                    </p>
                    <br />

                    <h1>
                        4. FALTAS Y SANCIONES
                    </h1>
                    <p>
                        <h2>
                            <ul>
                                <li>
                                    Faltas leves
                                </li>
                            </ul>
                        </h2>
                        <p>
                            Con el fin de mantener un ambiente seguro y respetuoso, las infracciones a las normas de convivencia se clasifican en faltas leves y faltas graves.
                            Se consideran faltas leves, entre otras:
                            <ul>
                                <li>
                                    Uso de lenguaje inapropiado o vulgar.
                                </li>
                                <li>
                                    Publicación de comentarios irrespetuosos.
                                </li>
                                <li>
                                    Conductas que generen malestar o incomodidad a otros usuarios.
                                </li>
                            </ul>
                            <br />
                            <strong>
                                Cabe destacar que la reincidencia en un tipo de falta leve se considerará como falta grave automáticamente.
                                <br />
                                <br />
                                Sanciones posibles:
                            </strong>
                            <ul>
                                <li>
                                    Aviso o advertencia por parte del equipo de moderación.
                                </li>
                                <li>
                                    Bloqueo temporal de la cuenta a criterio de los moderadores.
                                </li>
                            </ul>
                            <h2>
                                <ul>
                                    <li>
                                        Faltas graves
                                    </li>
                                </ul>
                            </h2>
                            Se consideran faltas graves:
                            <ul>
                                <li>
                                    Acoso, hostigamiento, amenazas o “stalking” hacia otros usuarios.
                                </li>
                                <li>
                                    Publicación de contenido violento, sexual explícito o discriminatorio.
                                </li>
                                <li>
                                    Intercambio, cesión o venta de cuentas.
                                </li>
                                <li>
                                    Suplantación de identidad.
                                </li>
                                <li>
                                    Cualquier conducta que ponga en riesgo la seguridad o integridad de la comunidad.
                                </li>
                            </ul>
                            <strong>
                                Cabe destacar que la reincidencia en un tipo de falta grave se considerará como falta muy grave automáticamente, vetando al usuario permanentemente de la plataforma.
                                <br />
                                <br />
                                Sanciones posibles:
                            </strong>
                            <ul>
                                <li>
                                    Bloqueo inmediato de la cuenta.
                                </li>
                                <li>
                                    Suspensión indefinida hasta que el usuario haya enmendado su conducta o hasta que el equipo de moderación lo considere apropiado.
                                </li>
                                <li>
                                    En casos extremos, eliminación definitiva de la cuenta.
                                </li>
                            </ul>
                        </p>
                    </p>
                    <br />
                    <h1>
                        5. MODERACIÓN
                    </h1>
                    <p>
                        El equipo de moderación tiene la <strong>autoridad para revisar, editar, ocultar o eliminar publicaciones (tanto públicas como privadas) y
                            cuentas que infrinjan las normas.</strong> Las decisiones de los moderadores se basarán en los presentes Términos y Condiciones siempre
                        buscando preservar el bienestar de la comunidad.
                    </p>
                    <br />
                    <h1>
                        6. PROPIEDAD INTELECTUAL
                    </h1>
                    <p>
                        El contenido publicado por los usuarios sigue siendo de su propiedad, pero al compartirlo en la Plataforma,
                        el usuario otorga a Yourny una licencia no exclusiva para mostrar, reproducir y distribuir dicho contenido dentro de la aplicación y/o dentro de
                        sus productos relacionados bajo previo aviso al usuario.
                    </p>
                    <br />
                    <h1>
                        7. LIMITACIÓN DE RESPONSABILIDAD
                    </h1>
                    <p>
                        Yourny no se hace responsable del contenido generado por los usuarios ni de las interacciones entre ellos. Cada usuario es responsable de su
                        comportamiento dentro y fuera de la Plataforma.
                    </p>
                    <br />
                    <h1>
                        8. MODIFICACIONES
                    </h1>
                    <p>
                        Yourny se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento.
                        Los cambios serán notificados a través de la Plataforma y entrarán en vigor desde su publicación.
                    </p>
                    <br/>
                    <h1>
                        9. CONTACTO
                    </h1>
                    <p>
                        Para consultas o reportes sobre el comportamiento de otros usuarios, puedes comunicarte con el equipo de soporte a través del correo: <a href="mailto:yourny.oficial+reportes@gmail.com">yourny.oficial+reportes@gmail.com</a>
                    </p>
                    <br/>
                    <br/>
                    <h1>
                        10. PROTECCIÓN DE DATOS Y PRIVACIDAD (RGPD)
                    </h1>
                    <p>
                        <h2>
                            <ul>
                                <li>
                                    Responsable del tratamiento

                                </li>
                            </ul>
                        </h2>
                        El responsable del tratamiento de los datos personales es:
                        <br />
                        Yourny
                        <br />
                        Correo electrónico de contacto: <a href="mailto:yourny.oficial+RGPD@gmail.com">yourny.oficial+RGPD@gmail.com</a>
                        <h2>
                            <ul>
                                <li>
                                    Datos personales que recopilamos
                                </li>
                            </ul>
                        </h2>
                        Durante el uso de la Plataforma, podremos recopilar los siguientes datos personales:
                        <ul>
                            <li>
                                Información de registro: nombre, correo electrónico y foto de perfil.
                            </li>
                            <li>
                                Contenido compartido: publicaciones, ubicación, fotografías, mensajes o cualquier otro material publicado por el usuario.
                            </li>
                            <li>
                                Datos técnicos: dirección IP, tipo de dispositivo, sistema operativo, idioma, país de conexión y cookies o tecnologías similares.
                            </li>
                        </ul>
                        <h2>
                            <ul>
                                <li>
                                    Finalidad del tratamiento
                                </li>
                            </ul>
                        </h2>

                        Los datos personales serán utilizados exclusivamente para los siguientes fines:
                        <ul>
                            <li>
                                Permitir el acceso y uso de la Plataforma.
                            </li>
                            <li>
                                Facilitar la interacción entre usuarios (mensajes, comentarios, publicaciones, etc.).
                            </li>
                            <li>
                                Gestionar la seguridad de las cuentas y la moderación de contenido.
                            </li>
                            <li>
                                Enviar notificaciones o comunicaciones relacionadas con el servicio.
                            </li>
                            <li>
                                Mejorar la experiencia del usuario y las funcionalidades de la aplicación.
                            </li>
                            <li>
                                Cumplir con las obligaciones legales aplicables.
                            </li>
                        </ul>

                        <h2>
                            <ul>
                                <li>
                                    Base legal para el tratamiento
                                </li>
                            </ul>
                        </h2>
                        El tratamiento de los datos personales se fundamenta en:
                        <ul>
                            <li>
                                El consentimiento expreso del usuario al registrarse y aceptar los presentes Términos y Condiciones.
                            </li>
                            <li>
                                La ejecución de un contrato, cuando el tratamiento es necesario para la prestación del servicio.
                            </li>
                            <li>
                                El interés legítimo de la Plataforma en mantener un entorno seguro y funcional.
                            </li>
                        </ul>
                        <h2>
                            <ul>
                                <li>
                                    Conservación de los datos
                                </li>
                            </ul>
                        </h2>
                        Los datos personales se conservarán mientras el usuario mantenga su cuenta activa.
                        <br />
                        En caso de eliminación o inactividad prolongada, los datos se eliminarán o anonimizarán, salvo aquellos que deban
                        conservarse por obligación legal.
                        <br/>
                        <br/>
                        <h2>
                            <ul>
                                <li>
                                    Derechos del usuario
                                </li>
                            </ul>
                        </h2>
                        El usuario puede ejercer en cualquier momento los siguientes derechos:
                        <ul>
                            <li>
                                Acceder a sus datos personales.
                            </li>
                            <li>
                                Solicitar la rectificación de datos inexactos.
                            </li>
                            <li>
                                Solicitar la supresión de sus datos (“derecho al olvido”) salvo que se encuentre en un proceso de investigación legal.
                            </li>
                            <li>
                                Limitar u oponerse al tratamiento.
                            </li>
                            <li>
                                Solicitar la portabilidad de los datos.
                            </li>
                            <li>
                                Retirar el consentimiento otorgado, sin que ello afecte la licitud del tratamiento previo.
                            </li>
                        </ul>
                        Para ejercer estos derechos, el usuario deberá enviar una solicitud escrita
                        a <a href="mailto:yourny.oficial+TDP@gmail.com">yourny.oficial+TDP@gmail.com</a> indicando el derecho que desea ejercer,
                        junto con una copia de un documento de identidad válido que acredite al usuario (por nombre y apellidos registrados en la Plataforma).
                        <br />
                        <br />
                        <strong>Yourny se reserva el derecho a pedir otras maneras de identificación del usuario.</strong>
                        <br />
                        <br/>
                        <h2>
                            <ul>
                                <li>
                                    Transferencias y almacenamiento de datos
                                </li>
                            </ul>
                        </h2>
                        Los datos personales serán tratados dentro del Espacio Económico Europeo (EEE). En caso de transferencia internacional,
                        se garantizarán medidas adecuadas conforme al RGPD (como cláusulas contractuales tipo o servicios certificados bajo el
                        marco UE–EE. UU. Data Privacy Framework).
                        <br />
                        <br />
                        <h2>
                            <ul>
                                <li>
                                    Seguridad de los datos
                                </li>
                            </ul>
                        </h2>
                        La Plataforma implementa medidas técnicas y organizativas adecuadas para proteger los datos personales frente a pérdida, alteración,
                        acceso no autorizado o divulgación indebida.
                        <br />
                        <br />
                        <h2>
                            <ul>
                                <li>
                                    Menores de edad
                                </li>
                            </ul>
                        </h2>
                        El registro en la Plataforma está restringido para menores de 16 años. En caso de detectar un registro de un menor sin el consentimiento
                        de sus padres o tutores legales, la cuenta será eliminada de inmediato.
                        <br />
                        <br />
                        <h2>
                            <ul>
                                <li>
                                    Actualizaciones de la política de privacidad
                                </li>
                            </ul>
                        </h2>
                    Yourny podrá actualizar esta sección para reflejar cambios en la legislación o en la forma en que se tratan los datos personales. 
                    Las modificaciones se comunicarán oportunamente al usuario mediante notificaciones en la Plataforma o por correo electrónico.
                    <br/>
                    <br/>
                    </p>
                </div>

            </div>
            <title>Términos y Condiciones</title>
        </>
    );
}



export default TyC;